import React from "react";
import tw from "twin.macro";
import { Icon } from "@components/Icon";
import { withShare } from "./withShare";
import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";

const Wrapper = tw.div`
  flex flex-row items-center
`;

const Button = withFocusRing(tw.button``);

const Title = tw.span`mr-micro`;

const Share = withShare(({ handleShare, image }) => {
  return (
    <Wrapper>
      <Title>Share</Title>
      <Button onClick={() => handleShare(`email`)}>
        <Icon name="email" size="xsmall" />
      </Button>
      <Button onClick={() => handleShare(`facebook`)}>
        <Icon name="facebook" size="sm" />
      </Button>
      {image.src && (
        <Button onClick={() => handleShare(`pinterest`, image)}>
          <Icon name="pinterest" size="sm" />
        </Button>
      )}
    </Wrapper>
  );
});

export default Share;
